import { render, staticRenderFns } from "./LmDocumentPreview.vue?vue&type=template&id=6ece22b6&scoped=true"
import script from "./LmDocumentPreview.vue?vue&type=script&lang=js"
export * from "./LmDocumentPreview.vue?vue&type=script&lang=js"
import style0 from "./LmDocumentPreview.vue?vue&type=style&index=0&id=6ece22b6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ece22b6",
  null
  
)

export default component.exports